
var Model = require("../types/DebouncedModel.js");
var xtend = require("xtend");
var Promise = require("promise");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

var SECTIONS = [
	"application",
	"account",
	"privacy",
	"contactSettings"
];


module.exports = Model({
	name: "profilesection",
	init: init,
	triggers: triggers,

	loadCached: loadCached,
});

function init() {

	var data = SECTIONS.reduce(function (result, name) {
		result.displaying[name] = false;
		return result;
	}, {
		displaying: {}
	});

	this.push(data);

	this.loadCached();
}

function triggers() {
	var display_toggles = SECTIONS.reduce(function (result, name) {
		result["toggle:" + name] = make_toggle(name);
		return result;
	}, {});

	return display_toggles;
}


function loadCached() {
	var model = this;
	Promise.all(SECTIONS.map(getShouldDisplay)).then(function(results) {
		model.extend({
			displaying: results.reduce(function(displaying, shouldDisplay, index){
				var name = SECTIONS[index];
				displaying[name] = shouldDisplay;
				return displaying;
			}, {})
		});
	});
}

function getShouldDisplay(name) {
	return AsyncStorage.getItem("profile_display_" + name).then(function(existing){
		if (existing === null) return true;
		return !!existing;
	});
}

function setShouldDisplay(name, displaying) {
	var key = "profile_display_" + name;
	if (!displaying) AsyncStorage.setItem(key, "");
	else AsyncStorage.setItem(key, Date.now().toString());
}

const sectionToName = {
	"application": "application settings",
	"account": "personal information",
	"contactSettings": "default contact settings",
	"privacy": "email privacy",
};

function make_toggle(name) {
	return function () {
		var shouldDisplay = !this.data.displaying[name];

		setShouldDisplay(name, shouldDisplay);

		var displayUpdate = {};
		displayUpdate[name] = shouldDisplay;
		var newDisplay = xtend(this.data.displaying, displayUpdate);

		this.extend({
			displaying: newDisplay
		});

		this.emit("usermetrics:trigger:track", `${shouldDisplay ? "unfold" : "fold"} ${sectionToName[name]} section in own account menu`, {
			displaying: shouldDisplay
		});
	};
}
